import { Provider, Signal } from "@angular/core";
import { ATOM_FORM_FIELD_OPTIONAL_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

/**
 * Localizes the copy the design system appends to the label of every
 * non-required control hosted in an `atom-form-field` (Forms Patterns HU-03).
 *
 * The token defaults to the English `(optional)` inside the library, so without
 * this provider the suffix ships untranslated in all four locales. The copy
 * carries its own parentheses — the design system only adds the separating
 * space — and consumers must never concatenate it into a label by hand.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomSelectInputLabels}.
 */
export const provideAtomFormFieldLabels = (): Provider[] => [
    {
        provide: ATOM_FORM_FIELD_OPTIONAL_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal("atom_form_field.optional_label"),
    },
];
